import { Button } from '@/atoms/Button'
import { AuthErrorBanner } from '@/molecules/AuthErrorBanner'
import { FormField } from '@/molecules/FormField'
import { useAgencyUserForm } from '@/modules/agencies/hooks/useAgencyUserForm'

export function AgencyUserForm() {
  const {
    isCreateMode,
    fields,
    fieldErrors,
    submitError,
    isSubmitting,
    closeForm,
    onFieldChange,
    onSubmit,
  } = useAgencyUserForm()

  return (
    <form className="flex flex-col gap-5" onSubmit={onSubmit} noValidate>
      <div className="flex flex-col gap-1">
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
          {isCreateMode ? 'New user' : 'Edit user'}
        </p>
        <h2
          id="agency-user-form-heading"
          className="font-display text-2xl font-medium tracking-[-0.02em] text-ink"
        >
          {isCreateMode ? 'Create user' : 'Update user'}
        </h2>
        <p className="text-sm text-muted">
          {isCreateMode
            ? 'Add a user to this agency with an email, role, and password.'
            : 'Update user details. Leave password blank to keep the current one.'}
        </p>
      </div>

      <AuthErrorBanner message={submitError} />

      <FormField
        label="First name"
        name="firstName"
        value={fields.firstName}
        placeholder="Ada"
        disabled={isSubmitting}
        error={fieldErrors.firstName ?? null}
        onChange={(value) => onFieldChange('firstName', value)}
      />

      <FormField
        label="Last name"
        name="lastName"
        value={fields.lastName}
        placeholder="Lovelace"
        disabled={isSubmitting}
        error={fieldErrors.lastName ?? null}
        onChange={(value) => onFieldChange('lastName', value)}
      />

      <FormField
        label="Email"
        name="email"
        type="email"
        value={fields.email}
        placeholder="ada@agency.test"
        autoComplete="email"
        disabled={isSubmitting}
        error={fieldErrors.email ?? null}
        onChange={(value) => onFieldChange('email', value)}
      />

      <FormField
        label={isCreateMode ? 'Password' : 'Password (optional)'}
        name="password"
        type="password"
        value={fields.password}
        placeholder={isCreateMode ? 'Minimum 8 characters' : 'Leave blank to keep current'}
        autoComplete="new-password"
        disabled={isSubmitting}
        error={fieldErrors.password ?? null}
        onChange={(value) => onFieldChange('password', value)}
      />

      <FormField
        label="Role"
        name="role"
        value={fields.role}
        placeholder="admin"
        disabled={isSubmitting}
        error={fieldErrors.role ?? null}
        onChange={(value) => onFieldChange('role', value)}
      />

      {isCreateMode ? null : (
        <FormField
          label="Status"
          name="status"
          value={fields.status}
          placeholder="active"
          disabled={isSubmitting}
          error={fieldErrors.status ?? null}
          onChange={(value) => onFieldChange('status', value)}
        />
      )}

      <div className="flex flex-wrap gap-3 pt-1">
        <Button type="submit" disabled={isSubmitting} className="min-w-36">
          {isSubmitting
            ? isCreateMode
              ? 'Creating…'
              : 'Saving…'
            : isCreateMode
              ? 'Create user'
              : 'Save changes'}
        </Button>
        <Button
          type="button"
          variant="ghost"
          disabled={isSubmitting}
          onClick={closeForm}
        >
          Cancel
        </Button>
      </div>
    </form>
  )
}
